var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.823346 0.823346C1.35075 0.296595 2.06568 0.000724281 2.81108 0.000724281C3.55648 0.000724281 4.2714 0.296595 4.79881 0.823346L15 11.0208L25.2012 0.823346C25.4622 0.562313 25.7721 0.35525 26.1132 0.21398C26.4542 0.0727104 26.8198 7.27695e-09 27.1889 0C27.5581 -7.27694e-09 27.9236 0.0727104 28.2647 0.21398C28.6057 0.35525 28.9156 0.562313 29.1767 0.823346C29.4377 1.08438 29.6447 1.39427 29.786 1.73532C29.9273 2.07638 30 2.44192 30 2.81108C30 3.18023 29.9273 3.54577 29.786 3.88683C29.6447 4.22789 29.4377 4.53778 29.1767 4.79881L18.9792 15L29.1767 25.2012C29.7038 25.7284 30 26.4434 30 27.1889C30 27.9345 29.7038 28.6495 29.1767 29.1767C28.6495 29.7038 27.9345 30 27.1889 30C26.4434 30 25.7284 29.7038 25.2012 29.1767L15 18.9792L4.79881 29.1767C4.27163 29.7038 3.55662 30 2.81108 30C2.06553 30 1.35052 29.7038 0.823346 29.1767C0.296166 28.6495 0 27.9345 0 27.1889C0 26.4434 0.296166 25.7284 0.823346 25.2012L11.0208 15L0.823346 4.79881C0.296595 4.2714 0.000724281 3.55648 0.000724281 2.81108C0.000724281 2.06568 0.296595 1.35075 0.823346 0.823346Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWhite);
export default __webpack_public_path__ + "static/media/XWhite.d7b41932aecc8260e509b2713373768b.svg";
export { ForwardRef as ReactComponent };